
import { crudSlice, noop } from 'saga-slice-helpers';

import { sagaApi } from '#/apis';

const sagaSliceModule = crudSlice({
    name: 'users',
    sagaApi,
    reducers: {

        resetPassword: noop,
        resetPasswordSuccess: noop,
        resetPasswordFail: noop,
        resetPasswordDone: noop,

        lock: noop,
        lockSuccess: noop,
        lockFail: noop,
        lockDone: noop,

        unlock: noop,
        unlockSuccess: noop,
        unlockFail: noop,
        unlockDone: noop,

        logout: noop,
        logoutSuccess: noop,
        logoutFail: noop,
        logoutDone: noop,


        uploadSignature: noop,
        uploadSignatureFail: noop,
        uploadSignatureSuccess: (state, payload) => {

            state.data[payload.id] = payload;
        },

        propertyAccess: noop,
        propertyAccessSuccess: (state, payload) => {
            state.data[payload.id] = payload;
        },
        propertyAccessFail: noop,

        departmentAccess: noop,
        departmentAccessSuccess: (state, payload) => {
            state.data[payload.id] = payload;
        },
        departmentAccessFail: noop


    },
    sagas: A => ({

        [A.resetPassword]: {
            *saga ({ payload: id }) {

                yield sagaApi.put(`/user/${id}/reset-password`, null, A.resetPasswordSuccess, A.resetPasswordFail, A.resetPasswordDone);
            }
        },
        [A.lock]: {
            *saga ({ payload: id }) {

                yield sagaApi.get(`/user/${id}/lock`, null, A.lockSuccess, A.lockFail, A.lockDone);
            }
        },
        [A.unlock]: {
            *saga ({ payload: id }) {

                yield sagaApi.get(`/user/${id}/unlock`, null, A.unlockSuccess, A.unlockFail, A.unlockDone);
            }
        },
        [A.logout]: {
            *saga ({ payload: id }) {

                yield sagaApi.get(`/user/${id}/logout`, null, A.logoutSuccess, A.logoutFail, A.logoutDone);
            }
        },
        [A.uploadSignature]: {
            *saga ({ payload }) {

                const { userId, file } = payload;
                delete payload.userId;
                yield sagaApi.post(`/users/${userId}/signature`, file, A.uploadSignatureSuccess, A.uploadSignatureFail);
            }
        },

        [A.propertyAccess]: function* ({ payload }) {
            const { user_id, properties } = payload;
            yield sagaApi.post(`/users/${user_id}/property-access`, { properties }, A.propertyAccessSuccess, A.propertyAccessFail);
        },
        [A.departmentAccess]: function* ({ payload }) {
            const { user_id, departments } = payload;
            yield sagaApi.post(`/users/${user_id}/department-access`, { departments }, A.departmentAccessSuccess, A.departmentAccessFail);
        }

    })
});

export const { actions } = sagaSliceModule;
export default sagaSliceModule;
